import { isEmpty } from 'lodash'

export default {
  ACCELERATION: {
    questionUuid: '3003938c-5e9e-3b8a-933c-4c1378a31b60',
    itemRowUuid: 'f4a42f0f-f46c-32d4-b7d4-e80544347a46',
    fieldUuid: '44118a89-b996-3241-8acc-c4d76128b8e7'
  },
  ASSOCIATION: {
    questionUuid: '3003938c-5e9e-3b8a-933c-4c1378a31b60',
    itemRowUuid: '1f9f3f73-fa47-3e09-8d7a-da88911be704',
    fieldUuid: '07f4bab6-ec47-3586-9a84-7ada8186fe52'
  },
  COWORKING: {
    questionUuid: '3003938c-5e9e-3b8a-933c-4c1378a31b60',
    itemRowUuid: '7ad80f89-f83e-3fed-a1e5-a71e916068c4',
    fieldUuid: 'cd50a5cb-67cd-386c-936d-97d7b0f5591b'
  },
  INCUBATION: {
    questionUuid: '3003938c-5e9e-3b8a-933c-4c1378a31b60',
    itemRowUuid: '2ff7a790-6759-39ac-af63-fe486656dad0',
    fieldUuid: 'b99a8e52-edc4-327c-8259-d77c62c8e820'
  },
  PRE_INCUBATION: {
    questionUuid: '3003938c-5e9e-3b8a-933c-4c1378a31b60',
    itemRowUuid: '1a22abe6-13f8-3682-af80-560fd482403d',
    fieldUuid: '64806d0b-6411-38d3-a1a4-7a07a220f4ea'
  },
  RESIDENCY: {
    questionUuid: '3003938c-5e9e-3b8a-933c-4c1378a31b60',
    itemRowUuid: '0d5ce468-b51d-32e5-ad51-b6b5d6972a0e',
    fieldUuid: 'dee67a3a-ddcb-39d9-84bd-8af513e85ce7'
  },
  has: (program, quizAnswers) => {
    const programsAnswer = quizAnswers.find(a => a.questionUuid === program.questionUuid)
    if (isEmpty(programsAnswer) || isEmpty(programsAnswer.value)) {
      return false
    }

    const programItemRowAnswer = programsAnswer.value.find(i => i.itemRowUuid === program.itemRowUuid)
    if (isEmpty(programItemRowAnswer) || isEmpty(programItemRowAnswer.fieldsAnswers)) {
      return false
    }

    const programFieldAnswer = programItemRowAnswer.fieldsAnswers.find(fa => fa.fieldUuid === program.fieldUuid)
    if (isEmpty(programFieldAnswer) || isEmpty(programFieldAnswer.value)) {
      return false
    }

    return programFieldAnswer.value.includes('Sim')
  }
}



// WEBPACK FOOTER //
// ./src/services/park_programs.js